import React from "react";
import { Baby, ShieldCheck, BadgePercent, Truck, RotateCcw } from "lucide-react";
import { whyUs } from "../mock";
import { SectionTitle } from "./ShopByAge";

const NAVY = "#1B1F5C";
const iconMap = { Baby, ShieldCheck, BadgePercent, Truck, RotateCcw };
const WhyParents = () => {
  return (
    <section className="py-10 md:py-14 bg-white relative overflow-hidden">
      {/* doodles */}
      <svg className="absolute top-14 left-6 w-7 h-7 text-[#F79433]" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8z"/></svg>
      <svg className="absolute bottom-10 right-8 w-6 h-6 text-[#F0426A]" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8z"/></svg>

      <div className="max-w-7xl mx-auto px-4">
        <SectionTitle>Why Parents Love Shopping with Us</SectionTitle>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {whyUs.map((w) => {
            const Icon = iconMap[w.icon];
            return (
              <div
                key={w.title}
                className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-transform duration-200 px-5 py-6 flex flex-col items-start text-left"
              >
                <span className="h-12 w-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: "#E7F8F8" }}>
                  <Icon size={22} className="text-[#35C3C1]" strokeWidth={1.8} />
                </span>
                <p className="text-[13.5px] font-extrabold" style={{ color: NAVY }}>{w.title}</p>
                <p className="mt-1 text-[12px] font-semibold text-gray-500 leading-snug">{w.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyParents;
